<template>
  <div class="documentation-container">
    <Header ref="Headers" />
    <CategoryView 
      categoryId="503"
      ref="categoryView"
    />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import CategoryView from "@/components/CategoryView.vue";

export default {
  components: {
    CategoryView,
    Header,
    Footer
  },
  activated() {
    this.$refs.Headers.switchTab(4);
    // 分类组件内部会自动加载数据
  }
};
</script>

<style scoped lang="scss">
// 主容器样式
.documentation-container {
  background: #ffffff;
  position: relative;
  min-height: 100vh;
}

// CSS变量用于主题定制
:deep(.category-view) {
  --theme-color: #ee0a24;
}
</style>